import { render, staticRenderFns } from "./CreateMatchDialog.vue?vue&type=template&id=1d1fcd88&scoped=true"
import script from "./CreateMatchDialog.vue?vue&type=script&lang=js"
export * from "./CreateMatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1fcd88",
  null
  
)

export default component.exports